/**
 * @generated SignedSource<<c94dc83cc616a8948c2f1ac5980785ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldInput_language$data = {
  readonly locale: Locale;
  readonly readOnly: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"LanguageIndicator_language" | "TranslatableTextFieldTranslateButton_to">;
  readonly " $fragmentType": "TranslatableTextFieldInput_language";
};
export type TranslatableTextFieldInput_language$key = {
  readonly " $data"?: TranslatableTextFieldInput_language$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_language">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldInput_language",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readOnly",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LanguageIndicator_language"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranslatableTextFieldTranslateButton_to"
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "eb41e37727505b6ffbc4645bed1c3a15";

export default node;
